simply.priceLogic = function(that){
	var parent = $(that).closest('.spinner');
  	var min_qty = $(parent).attr('data-min-qty'); 
	var value = $('.display_qty',parent).attr('data-value');
  	var visual_final_qty;
  	var display_unit = $(parent).attr('data-display-unit'); 
    if($(that).hasClass('plus')){
		visual_final_qty = parseFloat(value) + parseFloat(min_qty);	
    }else{
        visual_final_qty = parseFloat(value) - parseFloat(min_qty);
        if($('.template-product').length > 0){
          if(visual_final_qty == 0){
            visual_final_qty = parseFloat(min_qty);
          }
        }
    }
    var actual_final_qty = parseFloat(visual_final_qty) / parseFloat(min_qty);
    var actual_target = $('.actual_qty',parent);
    if(parseFloat(min_qty) < 1){
      $('.display_qty',parent).attr('data-value',visual_final_qty.toFixed(2));
    	$('.display_qty',parent).html(visual_final_qty.toFixed(2) + ' ' + display_unit);
    }else{
      $('.display_qty',parent).attr('data-value',visual_final_qty.toFixed(0));
      $('.display_qty',parent).html(visual_final_qty.toFixed(0) + ' ' + display_unit);
    }
  	
	$(actual_target).val(actual_final_qty).trigger('change');
    if($('.template-product').length > 0){
      var price = $(parent).attr('data-price');
      var comp_price = $(parent).attr('data-comp-price');
      price = parseInt(price) * actual_final_qty;
//       if(!cn(comp_price)){
//         comp_price = parseInt(comp_price) * actual_final_qty;
//         $('.product-price-compare.money').html(simply.formatMoney(comp_price, simply.money_format));;
//       }
      $('.total_money_span').html(simply.formatMoney(price, simply.money_format));
    }
  	
}
simply.clickEvent = function(){
    $(document).on('click','.plus',function(){
      simply.priceLogic($(this));
    });
    $(document).on('click','.minus',function(){
      simply.priceLogic($(this));
    });
    $(document).on('click','.sample-order .btn',function(){
      var btn = $(this);
      $(this).text('adding...');
      var vid = $(this).closest('.sample-order').attr('data-vid');
      var input = $('<input type="hidden" name="id" value="'+vid+'"/>');
      var form = $('<form>');
      form.append(input);
      simply.ajaxCart(form,function(){
          $(btn).text('added!')
          $('.sample_order_success').fadeIn();
          setTimeout(function(){ $(btn).text('Order Sample'); }, 3000);
      });
    });
};
simply.formatMoney = function(t, e) {
  function o(t, e) {
    return void 0 === t ? e : t
  }
  function i(t, e, i, r) {
    if (e = o(e, 2),
        i = o(i, ","),
        r = o(r, "."),
        isNaN(t) || null == t)
      return 0;
    t = (t / 100).toFixed(e);
    var n = t.split(".");
    return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (n[1] ? r + n[1] : "")
  }
  "string" == typeof t && (t = t.replace(".", ""));
  var r = ""
  , n = /\{\{\s*(\w+)\s*\}\}/
  , a = e || this.money_format;
  switch (a.match(n)[1]) {
    case "amount":
      r = i(t, 2);
      break;
    case "amount_no_decimals":
      r = i(t, 0);
      break;
    case "amount_with_comma_separator":
      r = i(t, 2, ".", ",");
      break;
    case "amount_with_space_separator":
      r = i(t, 2, " ", ",");
      break;
    case "amount_with_period_and_space_separator":
      r = i(t, 2, " ", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      r = i(t, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      r = i(t, 0, " ");
      break;
    case "amount_with_apostrophe_separator":
      r = i(t, 2, "'", ".")
  }
  return a.replace(n, r)
}


simply.ajaxCart = function(form,callback){
  data = form.serialize();
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function(line_item) {
      callback();
    },
    error: function(XMLHttpRequest, textStatus) {
      console.log(JSON.parse((XMLHttpRequest.responseText)).description);
      callback();
    }
  };
  jQuery.ajax(params);
};

$(document).ready(function() {
  simply.clickEvent();
});